import { useQuery } from '@tanstack/react-query'
import AppConfig from '../../model/AppConfig'
import { dataSource } from '../../service/domain/_service.config'

export const APP_CONFIG_QUERY_KEY = ['appConfig'] as const

export function useAppConfig() {
  return useQuery<AppConfig>({
    queryKey: APP_CONFIG_QUERY_KEY,
    queryFn: () => dataSource.getAppConfig(),
  })
}
